export interface Capabilities {
  webgpu: boolean;
  webgl2: boolean;
  webgl: boolean;
  webCodecs: boolean;
  offscreenCanvas: boolean;
  fileSystemAccess: boolean;
  opfs: boolean;
  indexedDb: boolean;
  sharedArrayBuffer: boolean;
  mediaRecorder: boolean;
}

export function detectCapabilities(): Capabilities {
  const canvas = document.createElement('canvas');
  return {
    webgpu: 'gpu' in navigator,
    webgl2: Boolean(canvas.getContext('webgl2')),
    webgl: Boolean(canvas.getContext('webgl')),
    webCodecs: 'VideoDecoder' in window && 'VideoEncoder' in window,
    offscreenCanvas: 'OffscreenCanvas' in window,
    fileSystemAccess: 'showOpenFilePicker' in window,
    opfs: Boolean(navigator.storage?.getDirectory),
    indexedDb: 'indexedDB' in window,
    sharedArrayBuffer: 'SharedArrayBuffer' in window && crossOriginIsolated,
    mediaRecorder: 'MediaRecorder' in window
  };
}
